'use strict';

module.exports = require('../5/CheckObjectCoercible');



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2016/RequireObjectCoercible.js
// module id = 345
// module chunks = 0